<template>
  <DashboardTemplate :navMenu="false" class="custom-certificate">
    <div v-loading="loading" class="box-share">
      <CertificateCard
        :name="user.nameTH"
        :lastName="user.surnameTH"
        :courseName="course.name"
        :endDate="successDate"
      />
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import SocialShare from "@/components/social/SocialShare";
import CertificateCard from "@/components/certificate/CertificateCard";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    SocialShare,
    CertificateCard,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      loading: true,
      courseId: "",
      userId: "",
      user: "",
      course: "",
      successDate: "",
    };
  },
  mounted() {
    this.setParams();
    this.fetchStudentsById();
    this.fetchCouseById();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        this.courseId = this.routeParams.courseId;
        this.userId = this.routeParams.userId;
        this.successDate = this.routeParams.endDate;
      }
    },
    fetchStudentsById() {
      let obj = {
        _id: this.userId,
      };

      HTTP.post(`get/student`, obj).then((res) => {
        if (res.data.success) {
          this.user = res.data.obj;
        }
      });
    },
    fetchCouseById() {
      HTTP.get(`course/${this.courseId}`)
        .then((res) => {
          if (res.data.success) {
            this.course = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCouseById error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>

<style scoped>
.box-share {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

